module.exports = __webpack_public_path__ + "static/media/SourceSansPro-BlackIt.47e5c307.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-BlackIt.eot
// module id = 92
// module chunks = 3